import { t as textSeparator, o as opportunity, v as clock, w as calendar, x as search, y as ellipsisV, z as amznAdsStormLogo, i as infoCircle, h as angleDown, A as angleUp, b as angleInlineEnd, B as angleInlineStart, s as spinner, c as check, e as exclamationTriangle, a as exclamation, f as externalLink, d as close } from '../localIcons-B_pWoZ1u-Bxh9jPb6.js';
import { b as angleDoubleRight, d as angleDoubleLeft } from '../classicIcons-Dl_q4l5f--kL9Y5b9.js';

const commonIconManifest = {
  close: close.icon,
  'external-link': externalLink.icon,
  exclamation: exclamation.icon,
  'exclamation-triangle': exclamationTriangle.icon,
  check: check.icon,
  spinner: spinner.icon,
  'angle-inline-start': angleInlineStart.icon,
  'angle-inline-end': angleInlineEnd.icon,
  'angle-up': angleUp.icon,
  'angle-down': angleDown.icon,
  'info-circle': infoCircle.icon,
  'amzn-ads-storm-logo': amznAdsStormLogo.icon,
  'ellipsis-v': ellipsisV.icon,
  search: search.icon,
  'angle-double-left': angleDoubleLeft.icon,
  'angle-double-right': angleDoubleRight.icon,
  calendar: calendar.icon,
  clock: clock.icon,
  opportunity: opportunity.icon,
  'text-separator': textSeparator.icon
};

export { commonIconManifest as c };
//# sourceMappingURL=commonIconManifest-ByI5cG6k-CRLbHB7E.js.map
